import { useEffect, useRef, useState } from 'react'

interface HubSpotMeetingEmbedProps {
  meetingUrl: string
  className?: string
}

export function HubSpotMeetingEmbed({ meetingUrl, className = '' }: HubSpotMeetingEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true
    script.onload = () => setIsLoading(false)
    script.onerror = () => setIsLoading(false)
    document.body.appendChild(script)

    const container = containerRef.current

    return () => {
      script.remove()
      // Clean up any iframe HubSpot may have injected
      if (container) {
        const iframe = container.querySelector('iframe')
        iframe?.remove()
      }
    }
  }, [])

  return (
    <div className={`rounded-xl overflow-hidden ${className}`}>
      {isLoading && (
        <div className="flex items-center justify-center py-20">
          <svg className="w-8 h-8 animate-spin text-accent-teal" viewBox="0 0 24 24" fill="none">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      )}
      <div
        ref={containerRef}
        className="meetings-iframe-container"
        data-src={`${meetingUrl}?embed=true`}
      />
    </div>
  )
}
